import Vue from 'vue'
// import axios from 'axios'
import axios from '@/wrappers/axios.js'
// import store from '../../store';

const TopicService = {

    topicList(params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/topics${params ? params : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    createTopic(data) {
        return new Promise(async (resolve, reject) => {
            axios
                .post(`/topics`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    getTopic(id, params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/topics/${id}${params ? params : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    delete(id) {
        return new Promise(async (resolve, reject) => {
            axios
                .delete(`/topics/${id}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },
    update(data,id) {
        return new Promise(async (resolve, reject) => {
            axios
                .put(`/topics/${id}`,data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },
}

Vue.$topicService = TopicService

export default TopicService;